"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyAll = exports.fetchFeaturesFailed = exports.fetchFeaturesSuccess = exports.fetchFeaturesRequest = exports.updatePrice = exports.unselect = exports.select = void 0;
const ActionTypes = require("../../../actionTypes/project/wizardSteps/step1_features");
const select = (feature) => ({
    type: ActionTypes.SELECT,
    payload: {
        feature
    }
});
exports.select = select;
const unselect = (feature) => ({
    type: ActionTypes.UNSELECT,
    payload: {
        feature
    }
});
exports.unselect = unselect;
const updatePrice = (uuid, price) => ({
    type: ActionTypes.UPDATE_PRICE,
    payload: {
        uuid,
        price
    }
});
exports.updatePrice = updatePrice;
const fetchFeaturesRequest = (uuid) => ({
    type: ActionTypes.FETCH_FEATURES_REQUEST,
    payload: {
        uuid
    }
});
exports.fetchFeaturesRequest = fetchFeaturesRequest;
const fetchFeaturesSuccess = (features) => ({
    type: ActionTypes.FETCH_FEATURES_SUCCESS,
    payload: {
        features
    }
});
exports.fetchFeaturesSuccess = fetchFeaturesSuccess;
const fetchFeaturesFailed = (error) => ({
    type: ActionTypes.FETCH_FEATURES_FAILED,
    payload: {
        error
    }
});
exports.fetchFeaturesFailed = fetchFeaturesFailed;
const copyAll = (features) => ({
    type: ActionTypes.COPY_ALL,
    payload: {
        features
    }
});
exports.copyAll = copyAll;
//# sourceMappingURL=step1_features.js.map